import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@/api/client';

export type OutreachReadiness = {
  ready: boolean;
  checks: { id: string; ok: boolean; message: string }[];
};

export function useOutreachReadiness(
  projectId: string | undefined,
  sendRail?: 'smtp' | 'brevo_transactional',
) {
  const railQuery =
    sendRail === 'brevo_transactional' ? '?send_rail=brevo_transactional' : '';
  return useQuery({
    queryKey: ['outreach-readiness', projectId, sendRail ?? 'smtp'],
    enabled: Boolean(projectId),
    queryFn: () =>
      apiFetch<{ readiness: OutreachReadiness }>(
        `/api/projects/${projectId}/outreach-readiness${railQuery}`,
      ),
  });
}
